import BaseDocumentRequest from "../../components/BaseDocumentRequest/BaseDocumentRequest";
import { fsrConfig } from "../../components/BaseDocumentRequest/config/fsrConfig";

const FacultyServiceRecord = () => {
  return <BaseDocumentRequest {...fsrConfig} />;
};

export default FacultyServiceRecord;
